module.exports = __webpack_public_path__ + "static/media/first.39f0600a.gif";